<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="sp" id="ded"> </p>
<p class="Dedication-ded"><span epub:type="pagebreak" id="pg_5" title="5">To Rick and Rich Wilber, and all those tight games.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?0d2d9dba